export default {
    'arrived': 'Arrived',
    'token_x': 'Token {tokenNo}',
    'could_not_mark_the_arrival': 'Could not mark the arrival',
    'x_a_refund_is_due': '{what} — a refund is due',
    'the_fee_was_already_paid_the_appointment_is': 'The fee was already paid. The appointment is flagged until the refund or credit note is recorded.',
    'x_unpaid_fee_invoice_s_were_cancelled_with_it': '{cancelledInvoices} unpaid fee invoice(s) were cancelled with it',
    'could_not_update_the_appointment': 'Could not update the appointment',
    'appointments': 'Appointments',
    'bookings_for_the_selected_day': 'Bookings for the selected day',
    'walk_in': 'Walk-in',
    'book_appointment': 'Book appointment',
    'all_statuses': 'All statuses',
    'search_name_mrn_or_phone': 'Search name, MRN or phone',
    'fee_alerts_only_any_date': 'Fee alerts only (any date)',
    'list': 'List',
    'day_board': 'Day board',
    'no_appointments_for_this_day': 'No appointments for this day.',
    'time': 'Time',
    'token': 'Token',
    'patient': 'Patient',
    'doctor': 'Doctor',
    'visit': 'Visit',
    'free': 'free',
    'see_first': 'see first',
    'refund_due': 'refund due',
    'doctor_changed_check_fee': 'doctor changed — check fee',
    'status': 'Status',
    'confirm': 'Confirm',
    'no_show': 'No-show',
    'slip': 'Slip',
    'left_without_being_seen': 'Left without being seen',
    'move': 'Move',
    'payer': 'Payer',
    'settle_fee_alert': 'Settle fee alert',
    'cancel': 'Cancel',
    'appointment_cancelled_a_refund_is_due': 'Appointment cancelled — a refund is due',
    'the_fee_was_already_paid_record_the_refund_then': 'The fee was already paid. Record the refund, then settle the alert.',
    'appointment_cancelled': 'Appointment cancelled',
    'cancel_the_appointment': 'Cancel the appointment',
    'x_with_x_x': '{fullName} with {name}, {slotAt}',
    'keep_it': 'Keep it',
    'cancel_appointment': 'Cancel appointment',
    'why_is_it_being_cancelled': 'Why is it being cancelled?',
    'choose_a_reason': 'Choose a reason',
    'note': 'Note',
    'fee_alert_settled': 'Fee alert settled',
    'settle_the_fee_alert': 'Settle the fee alert',
    'close': 'Close',
    'settle': 'Settle',
    'paid': 'Paid',
    'refunded': '· refunded',
    'credited': '· credited',
    'no_approved_refund_or_issued_credit_note_is': 'No approved refund or issued credit note is recorded for this visit yet. Record it in Billing first, then settle the alert here.',
    'settled_by': 'Settled by',
    'refund_of': 'Refund of',
    'credit_note_for': 'Credit note for',
    'nothing_is_owed_back_waive_the_alert': 'Nothing is owed back — waive the alert',
    'why_nothing_is_owed_back': 'Why nothing is owed back',
    'at_least_ten_characters_kept_with_the': 'At least ten characters; kept with the appointment',
    'appointment_booked': 'Appointment booked',
    'fee_quoted_x': 'Fee quoted: {value}',
    'book_an_appointment': 'Book an appointment',
    'booking_section_when': 'Doctor and time',
    'booking_section_visit': 'Visit details',
    'pick_the_patient_the_doctor_and_a_free_slot': 'Pick the patient, the doctor and a free slot',
    'book_overbook_seat': 'Book overbook seat',
    'book': 'Book',
    'select_a_doctor': 'Select a doctor',
    'date': 'Date',
    'slot': 'Slot',
    'no_clinic_on_this_day': 'No clinic on this day',
    'checking_availability': 'Checking availability…',
    'full_overbook_seat_available': 'Full — overbook seat available',
    'this_doctor_has_no_clinic_on_the_selected_day': 'This doctor has no clinic on the selected day. Publish their weekly hours under',
    'today_clinic_hours': 'Today → Clinic hours',
    'visit_type': 'Visit type',
    'new': 'New',
    'follow_up': 'Follow-up',
    'reason': 'Reason',
    'presenting_complaint': 'Presenting complaint',
    'booking_for': 'Booking for',
    'book_as_follow_up': 'Book as follow-up',
    'is_full_book_into_an_overbook_seat': 'is full. Book into an overbook seat —',
    'left_the_doctor_will_see_one_extra_patient_in': 'left. The doctor will see one extra patient in this slot.',
    'of': 'of',
    'bookings_moved': 'bookings moved.',
    'done': 'Done',
    'booking_s_fall_inside_this_leave_move_them_now': 'booking(s) fall inside this leave. Move them now, or call the patients.',
    'move_to_doctor': 'Move to doctor',
    'on': 'On',
    'x_free_slot_s': '{length} free slot(s)',
    'send_the_patients_an_sms': 'Send the patients an SMS',
    'only': 'Only',
    'free_slot_s_that_day_the_rest_stay_where_they': 'free slot(s) that day; the rest stay where they are.',
    'leave_them': 'Leave them',
    'certificate_withdrawn': 'Certificate withdrawn',
    'could_not_withdraw_the_certificate': 'Could not withdraw the certificate',
    'certificates': 'Certificates',
    'issue_certificate': 'Issue certificate',
    'none_issued_in_this_visit': 'None issued in this visit.',
    'withdrawn': 'withdrawn',
    'print': 'Print',
    'withdraw': 'Withdraw',
    'withdraw_the_certificate': 'Withdraw the certificate',
    'the_print_will_read_cancelled_with_the_reason': 'The print will read CANCELLED with the reason',
    'issue_a_certificate': 'Issue a certificate',
    'issue_and_print': 'Issue and print',
    'type': 'Type',
    'from': 'From',
    'remarks_or_restrictions': 'Remarks or restrictions',
    'seha_reference': 'Seha reference',
    'needed_in_saudi_arabia_register_the_leave_in': 'Needed in Saudi Arabia: register the leave in Seha first',
    'text_printed_on_the_certificate': 'Text printed on the certificate',
    'could_not_open_the_report': 'Could not open the report',
    'laboratory': 'Laboratory (',
    'no_tests_ordered_in_this_visit': 'No tests ordered in this visit.',
    'view_report': 'View report',
    'pending_verification': 'Pending verification',
    'imaging': 'Imaging (',
    'no_imaging_ordered_in_this_visit': 'No imaging ordered in this visit.',
    'report_pending_verification': 'Report pending verification',
    'investigations_advised_outside': 'Investigations advised outside (',
    'laboratory_2': 'Laboratory',
    'imaging_2': 'Imaging',
    'opening_the_consultation': 'Opening the consultation…',
    'that_consultation_could_not_be_opened': 'That consultation could not be opened.',
    'x_started_x_x': '{mrn} · started {startedAt} · {context}',
    'full_record': 'Full record',
    'record_vitals': 'Record vitals',
    'statement': 'Statement',
    'print_note': 'Print note',
    'visit_summary': 'Visit summary',
    'waiver_request_sent_to_the_cash_counter': 'Waiver request sent to the cash counter',
    'could_not_send_the_waiver_request': 'Could not send the waiver request',
    'request_fee_waiver': 'Request fee waiver',
    'closed': 'Closed',
    'allergies': 'Allergies',
    'bp': 'BP',
    'pulse': 'Pulse',
    'temp': 'Temp',
    'spo': 'SpO₂',
    'weight': 'Weight',
    'bmi': 'BMI',
    'abnormal_values': 'Abnormal values',
    'clinical_note': 'Clinical note',
    'diagnosis': 'Diagnosis',
    'prescription': 'Prescription',
    'orders': 'Orders',
    'forms': 'Forms',
    'attachments': 'Attachments',
    'previous_visits': 'Previous visits',
    'follow_up_date_saved': 'Follow-up date saved',
    'follow_up_cleared': 'Follow-up cleared',
    'reception_sees_it_in_follow_ups_due_and_reminds': 'Reception sees it in Follow-ups due and reminds the patient the day before',
    'the_follow_up_date_could_not_be_saved': 'The follow-up date could not be saved',
    'ask_the_patient_to_come_back_on': 'Ask the patient to come back on',
    'save_follow_up_date': 'Save follow-up date',
    'no_follow_up_needed': 'No follow-up needed',
    'addendum_added': 'Addendum added',
    'it_is_signed_with_your_name_and_the_time_and': 'It is signed with your name and the time, and cannot be edited',
    'the_addendum_could_not_be_added': 'The addendum could not be added',
    'addenda': 'Addenda',
    'the_note_is_closed_anything_that_must_be_added': 'The note is closed. Anything that must be added later goes here, signed and dated, beneath the original note.',
    'unknown': 'Unknown',
    'new_addendum': 'New addendum',
    'add_addendum': 'Add addendum',
    'the_note_could_not_be_saved': 'The note could not be saved',
    'closed_read_only': 'Closed — read only',
    'saving': 'Saving…',
    'unsaved_changes': 'Unsaved changes',
    'saved_x': 'Saved {savedAt}',
    'autosaves_as_you_type': 'Autosaves as you type',
    'diagnoses_saved': 'Diagnoses saved',
    'could_not_save_the_diagnoses': 'Could not save the diagnoses',
    'search_icd_10': 'Search ICD-10',
    'code_or_description_misspellings_are_tolerated': 'Code or description — misspellings are tolerated',
    'no_match': 'No match.',
    'this_visit': 'This visit',
    'save_diagnoses': 'Save diagnoses',
    'no_diagnosis_recorded_one_is_required_before': 'No diagnosis recorded. One is required before the consultation can be closed.',
    'onset': 'Onset',
    'onset_not_stated': 'Onset not stated',
    'problem_list': 'Problem list',
    'primary': 'primary',
    'remove': 'Remove',
    'prescription_issued': 'Prescription issued',
    'it_is_now_in_the_pharmacy_queue': 'It is now in the pharmacy queue',
    'could_not_issue_the_prescription': 'Could not issue the prescription',
    'safety_checks': 'Safety checks',
    'acknowledge': 'Acknowledge',
    'new_prescription': 'New prescription',
    'add_medicine': 'Add medicine',
    'acknowledge_the_severe_warnings_first': 'Acknowledge the severe warnings first',
    'choose_the_route_for_x': 'Choose the route for {value}',
    'issue_and_print_2': 'Issue & print',
    'medicine': 'Medicine',
    'strength': 'Strength',
    '500_mg': '500 mg',
    'dose': 'Dose',
    '1_tablet': '1 tablet',
    'frequency': 'Frequency',
    'tds': 'TDS',
    'days': 'Days',
    'form': 'Form',
    'tablet': 'Tablet',
    'route': 'Route',
    'choose_the_route': 'Choose the route',
    'qty': 'Qty',
    'blank_estimated_from_the_frequency_and_days': 'Blank: estimated from the frequency and days',
    'instructions': 'Instructions',
    'after_meals': 'After meals',
    'sos': 'SOS',
    'remove_medicine': 'Remove medicine',
    'advice_printed_on_the_prescription': 'Advice printed on the prescription',
    'issued_this_visit': 'Issued this visit',
    'prescription_cancelled': 'Prescription cancelled',
    'cancel_prescription_title': 'Cancel this prescription',
    'cancel_prescription_description': 'Why is this prescription being cancelled? The reason stays on the record.',
    'cancel_prescription': 'Cancel prescription',
    'could_not_cancel_the_prescription': 'Could not cancel the prescription',
    'co_signed': 'Co-signed',
    'could_not_co_sign': 'Could not co-sign',
    'co_sign': 'Co-sign',
    'consultations_closed_by_medical_officers': 'Consultations closed by medical officers, waiting for a senior doctor\'s co-signature',
    'nothing_is_waiting_for_a_co_signature': 'Nothing is waiting for a co-signature.',
    'seen_by': 'Seen by',
    'read': 'Read',
    'next_page': 'Next page',
    'co_sign_x': 'Co-sign {fullName}',
    'seen_by_x': 'Seen by {name}',
    'note_optional': 'Note (optional)',
    'your_account_has_no_branch_ask_an_administrator': 'Your account has no branch; ask an administrator to set one.',
    'no_clinics_on_this_day': 'No clinics on this day.',
    'no_bookings': 'No bookings',
    'previous': 'Previous',
    'next_doctors': 'Next doctors',
    'search_the_formulary': 'Search the formulary',
    'paracetamol': 'Paracetamol',
    'could_not_save': 'Could not save',
    'no_known_allergies': 'No known allergies',
    'checked_x': ', checked {allergiesVerifiedAt}',
    'allergies_not_recorded_ask_the_patient_then': 'Allergies not recorded. Ask the patient, then record them or mark no known allergies.',
    'chief_complaint': 'Chief complaint',
    'for': 'For',
    'unit': 'Unit',
    'review_of_systems': 'Review of systems',
    'all_normal_except_marked': 'All normal except marked',
    'not_asked': 'not asked',
    'findings': 'Findings',
    'could_not_remove_the_allergy': 'Could not remove the allergy',
    'remove_allergy_title': 'Remove the allergy to {substance}',
    'remove_allergy_description': 'Why is this allergy being removed? The reason stays on the record.',
    'not_recorded': 'Not recorded',
    'substance': 'Substance',
    'reaction': 'Reaction',
    'add': 'Add',
    'checked_with_the_patient_today': 'Checked with the patient today',
    'could_not_record_the_answer': 'Could not record the answer',
    'current_medicines': 'Current medicines',
    'nothing_prescribed_here_in_the_last_year_is': 'Nothing prescribed here in the last year is still running.',
    'still_taking': 'Still taking',
    'stopped': 'Stopped',
    'could_not_update_the_problem': 'Could not update the problem',
    'could_not_remove_the_problem': 'Could not remove the problem',
    'no_long_term_conditions_recorded_add_one_from_a': 'No long-term conditions recorded. Add one from a diagnosis.',
    'resolved': 'Resolved',
    'active_again': 'Active again',
    'entered_in_error': 'Entered in error',
    'remove_problem_title': 'Take {problem} off the problem list',
    'remove_problem_description': 'Why was this entered in error? The reason is kept in the audit trail.',
    'for_the_insurance_claim': 'For the insurance claim',
    'consultation_closed': 'Consultation closed',
    'the_appointment_is_marked_completed': 'The appointment is marked completed',
    'could_not_close_the_consultation': 'Could not close the consultation',
    'record_a_diagnosis_first': 'Record a diagnosis first',
    'close_consultation': 'Close consultation',
    'close_the_consultation': 'Close the consultation',
    'close_and_sign': 'Close and sign',
    'how_does_the_visit_end': 'How does the visit end?',
    'a_letter_to_the_family_doctor_prints_after': 'A letter to the family doctor prints after closing.',
    'follow_up_updated': 'Follow-up updated',
    'could_not_update_the_follow_up': 'Could not update the follow-up',
    'follow_ups_due': 'Follow-ups due',
    'patients_a_doctor_asked_to_see_again_they_get_a': 'Patients a doctor asked to see again. They get a reminder message the day before.',
    'to_book': 'To book',
    'booked': 'Booked',
    'seen': 'Seen',
    'due_within_a_week_and_overdue': 'Due within a week (and overdue)',
    'nobody_is_waiting_to_be_booked_for_a_follow_up': 'Nobody is waiting to be booked for a follow-up.',
    'nothing_here_yet': 'Nothing here yet.',
    'due': 'Due',
    'overdue': 'overdue',
    'today': 'today',
    'reminder': 'Reminder',
    'sent': 'sent',
    'not_yet': 'not yet',
    'not_needed': 'Not needed',
    'show_more': 'Show more',
    'walk_in_queued': 'Walk-in queued',
    'walk_in_patient': 'Walk-in patient',
    'queue_the_patient_now_and_print_the_token': 'Queue the patient now and print the token',
    'it_is_someone_new': 'It is someone new',
    'queue_and_print_token': 'Queue and print token',
    'full_name': 'Full name',
    'mobile': 'Mobile',
    'sex': 'Sex',
    'male': 'Male',
    'female': 'Female',
    'other': 'Other',
    'age_years': 'Age (years)',
    'pick_a_registered_patient_instead': 'Pick a registered patient instead',
    'new_patient_register_quickly': 'New patient — register quickly',
    'these_patients_have_the_same_name_and_mobile': 'These patients have the same name and mobile number:',
    'use_this_patient': 'Use this patient',
    'priority': 'Priority',
    'routine': 'Routine',
    'see_first_2': 'See first',
    'why_first': 'Why first',
    'choose': 'Choose',
    'clinical_need': 'Clinical need',
    'elderly': 'Elderly',
    'disability': 'Disability',
    'pregnant': 'Pregnant',
    'young_child': 'Young child',
    'complaint': 'Complaint',
    'appointment_moved': 'Appointment moved',
    'move_the_appointment': 'Move the appointment',
    'x_now_x': '{fullName} · now {slotAt}',
    'payer_updated': 'Payer updated',
    'who_pays_for_this_visit': 'Who pays for this visit',
    'save': 'Save',
    'self_pay': 'Self-pay',
    'why_the_payer_is_changing': 'Why the payer is changing',
    'template_saved': 'Template saved',
    'insert_template': 'Insert template',
    'insert_template_2': 'Insert template…',
    'save_as_template': 'Save as template',
    'the_filled_parts_of_this_note_become_a_template': 'The filled parts of this note become a template you can insert later',
    'name': 'Name',
    'share_with_every_doctor': 'Share with every doctor',
    'clinic_setting_saved': 'Clinic setting saved',
    'could_not_save_the_setting': 'Could not save the setting',
    'outpatient_clinic_day': 'Outpatient clinic day',
    'pay_bill': 'Pay bill',
    'nothing_left_to_pay_on_this_visit': 'Nothing left to pay on this visit',
    'could_not_open_the_bill': 'Could not open the bill',
    'emr_menu': 'EMR sections',
    'emr_group_visit': 'This visit',
    'emr_group_orders': 'Treatment & orders',
    'emr_group_record': 'Patient record',
    'emr_group_documents': 'Documents',
    'emr_group_forms': 'Clinical forms',
    'emr_summary': 'Summary',
    'emr_vitals': 'Vitals',
    'emr_complaint_history': 'Complaint & history',
    'emr_examination': 'Examination',
    'emr_plan_follow_up': 'Plan & follow-up',
    'emr_lab_imaging': 'Lab & imaging',
    'emr_current_medicines': 'Current medicines',
    'emr_care_team': 'Care team',
    'emr_history': 'History',
    'note_presenting_complaints': 'Presenting complaints',
    'note_history_of_present_illness': 'History of present illness',
    'note_past_history': 'Past history',
    'note_surgical_history': 'Surgical history',
    'note_family_history': 'Family history',
    'note_social_history': 'Social history',
    'note_drug_history': 'Drug history',
    'note_examination': 'Examination findings',
    'note_plan': 'Plan',
    'note_advice': 'Advice',
    'vital_bp': 'Blood pressure',
    'vital_pulse': 'Pulse',
    'vital_temperature': 'Temperature',
    'vital_spo2': 'SpO₂',
    'vital_resp_rate': 'Resp. rate',
    'vital_weight': 'Weight',
    'vital_height': 'Height',
    'vital_bmi': 'BMI',
    'vital_sugar': 'Blood sugar',
    'vital_pain': 'Pain',
    'vital_below_range': 'Below the normal range',
    'vital_above_range': 'Above the normal range',
    'vitals_bp_systolic': 'BP systolic',
    'vitals_bp_diastolic': 'BP diastolic',
    'vitals_pulse_per_min': 'Pulse (/min)',
    'vitals_resp_rate_per_min': 'Resp. rate (/min)',
    'vitals_temperature_c': 'Temperature (°C)',
    'vitals_spo2_pct': 'SpO₂ (%)',
    'vitals_height_cm': 'Height (cm)',
    'vitals_weight_kg': 'Weight (kg)',
    'vitals_blood_sugar_mg_dl': 'Blood sugar (mg/dL)',
    'vitals_head_circumference_cm': 'Head circumference (cm)',
    'vitals_head_circumference_hint': 'Children',
    'vitals_save': 'Save vitals',
    'vitals_recorded': 'Vitals recorded',
    'vitals_record_failed': 'Could not record vitals',
    'vitals_enter_a_reading': 'Enter at least one reading to save',
    'vitals_bp_pair': 'Record the systolic and the diastolic pressure together',
    'vitals_bp_order': 'The systolic pressure must be higher than the diastolic',
    'vitals_height_weight_mismatch': 'Height and weight do not fit together (BMI {bmi})',
    'vitals_recheck': 'Recheck vitals',
    'vitals_recheck_title': 'Vitals were already taken for this visit',
    'vitals_recheck_body': 'This set is saved as a recheck. Say why the reading was repeated.',
    'vitals_recheck_reason': 'Reason for the recheck',
    'vitals_recheck_reason_placeholder': 'e.g. BP high, rechecked after rest',
    'vitals_recheck_reason_required': 'Give a reason for the recheck',
    'vitals_save_recheck': 'Save recheck',
    'vitals_recheck_recorded': 'Recheck recorded',
    'vitals_group_circulation': 'Circulation',
    'vitals_group_respiration': 'Respiration',
    'vitals_group_body': 'Body',
    'vitals_group_other': 'Other',
    'vitals_flag_high': 'High',
    'vitals_flag_low': 'Low',
    'vitals_bmi_from_height_weight': 'Enter height and weight',
    'emr_age_years': '{n} y',
    'emr_age_months': '{n} mo',
    'emr_age_years_approx': '~{n} y',
    'emr_allergies_not_recorded': 'Allergies not recorded yet',
    'emr_active_problems': 'Active problems',
    'emr_insured': 'Insured',
    'emr_in_progress': 'In progress',
    'emr_vitals_taken': 'Vitals taken',
    'emr_no_vitals_yet': 'No vitals recorded for this visit yet',
    'emr_taken_at': 'Taken at',
    'emr_latest_reading_x': 'Latest reading {time}',
    'emr_vitals_history': 'Earlier readings',
    'emr_vitals_rechecked': 'Rechecked',
    'emr_recheck_badge': 'Recheck',
    'emr_recheck_reason_x': 'Recheck: {reason}',
    'emr_treatment_ordered': 'Treatment or tests ordered',
    'emr_empty_complaint': 'Record the chief complaint and history',
    'emr_for_x': 'for {value}',
    'emr_empty_examination': 'Record the examination findings',
    'emr_abnormal_systems': 'Abnormal:',
    'emr_ros_all_normal': 'Review of systems: all normal',
    'emr_empty_diagnosis': 'Add a diagnosis — needed before closing',
    'emr_empty_plan': 'Write the plan, advice and follow-up',
    'emr_follow_up_on_x': 'Follow-up on {date}',
    'emr_empty_prescription': 'No prescription issued yet',
    'emr_empty_orders': 'No lab tests or imaging ordered',
    'emr_complaint_desc': 'Why the patient came and the story behind it',
    'emr_examination_desc': 'What you found on examining the patient',
    'emr_plan_desc': 'The plan, advice for the patient and when to come back',
    'emr_desc_ros': 'Go through each body system; mark anything abnormal',
    'emr_desc_diagnosis': 'Search ICD-10 and mark the primary diagnosis',
    'emr_desc_prescription': 'Medicines for this visit, checked for allergies and interactions',
    'emr_desc_orders': 'Lab tests, imaging and other orders for this visit',
    'emr_desc_lab_order': 'Tests for this visit, done here or at another lab',
    'emr_desc_radiology_order': 'Imaging for this visit, done here or elsewhere',
    'emr_desc_procedure_order': 'Procedures for this visit, with referral and admission',
    'emr_empty_lab_order': 'No lab tests ordered',
    'emr_empty_radiology_order': 'No imaging ordered',
    'emr_empty_procedure_order': 'No procedures ordered',
    'order_new_lab': 'New lab order',
    'order_new_radiology': 'New imaging order',
    'order_new_procedure': 'New procedure order',
    'order_search_lab': 'Search tests and panels',
    'order_search_radiology': 'Search imaging studies',
    'order_search_procedure': 'Search procedures',
    'order_catalogue_nothing': 'Nothing in the catalogue matches',
    'order_catalogue_empty': 'Nothing of this kind is in the catalogue yet',
    'order_load_more': 'Load more',
    'order_add_x': 'Add {name}',
    'order_panel': 'Panel',
    'order_no_price': 'No price',
    'order_outside_only': 'Outside only',
    'order_cannot_be_done_here': 'Cannot be done here, so the patient has it done elsewhere',
    'order_done_here': 'Done here',
    'order_outside': 'Outside',
    'order_who_does_it': 'Where it is done',
    'order_quantity': 'Quantity',
    'order_decrease_x': 'One fewer {name}',
    'order_increase_x': 'One more {name}',
    'order_remove_x': 'Remove {name}',
    'order_add_note': 'Add a note',
    'order_line_note': 'Note for this item',
    'order_line_note_for_x': 'Note for {name}',
    'order_draft_title': 'This order',
    'order_draft_empty': 'Pick from the list to add it here. Pick it again to raise the quantity.',
    'order_billed_here_x': 'Billed here: {amount}',
    'order_indication': 'Clinical indication',
    'order_indication_hint': 'Why these are needed; it travels with the order',
    'order_place_x': 'Place order ({count})',
    'order_placed_lab': 'Lab order placed',
    'order_placed_radiology': 'Imaging order placed',
    'order_placed_procedure': 'Procedure order placed',
    'order_placed_in_house': 'Items done here are billed on the visit and start once paid',
    'order_placed_outside': 'Print the requisition for the patient to take',
    'order_lines_lab': 'Lab orders of this visit',
    'order_lines_radiology': 'Imaging of this visit',
    'order_lines_procedure': 'Procedures of this visit',
    'order_lines_empty': 'Nothing ordered yet',
    'order_billing_paid': 'Paid',
    'order_billing_unpaid': 'Awaiting payment',
    'order_billing_not_billed': 'Not billed',
    'order_waits_for_payment': 'Waits for payment at the counter before it is done',
    'order_outside_hint': 'Done outside; attach the result when the patient brings it',
    'order_cancelled_x': 'Cancelled: {reason}',
    'order_print_requisition': 'Requisition',
    'order_attach_result': 'Attach result',
    'order_cancel_line': 'Cancel order',
    'order_cancel_title': 'Cancel {name}?',
    'order_cancel_description': 'Only work nobody has started can be cancelled. An unpaid bill line goes with it.',
    'order_cancelled': 'Order cancelled',
    'order_cancelled_refund': 'Order cancelled; a refund is due at the counter',
    'order_could_not_cancel': 'Could not cancel the order',
    'order_referral_admission': 'Referral & admission',
    'order_referral_admission_desc': 'Refer to a colleague or another hospital, or ask the ward to admit',
    'order_no_referral_or_admission': 'No referral or admission request for this visit yet',
    'emr_desc_allergies': 'Known allergies, checked against every prescription',
    'emr_desc_medicines': 'Medicines the patient is taking now',
    'emr_desc_problems': 'Long-term conditions carried from visit to visit',
    'emr_desc_history': 'What happened at the patient\'s earlier visits',
    'emr_desc_files': 'Reports, scans and photos attached to this visit',
    'emr_desc_certificates': 'Sick-leave and fitness certificates',
    'emr_desc_care_team': 'Other staff helping with this visit',
    'emr_desc_addenda': 'Signed additions to the closed note',
    'emr_form_vitals': 'Vitals',
    'emr_form_complaint_history': 'Complaint and history',
    'emr_form_review_of_systems': 'Review of systems',
    'emr_form_examination': 'Examination',
    'emr_form_diagnosis': 'Diagnosis',
    'emr_form_plan_follow_up': 'Plan and follow-up',
    'emr_form_prescription': 'Prescription',
    'emr_form_progress_note': 'Progress note',
    'emr_form_lab_order': 'Lab order',
    'emr_form_radiology_order': 'Radiology order',
    'emr_form_procedure_order': 'Procedure order',
    'emr_form_medication_order': 'Medication order',
    'emr_form_iv_fluid_order': 'IV fluid order',
    'emr_form_diet_order': 'Diet order',
    'emr_form_nursing_order': 'Nursing order',
    'emr_form_blood_transfusion_order': 'Blood transfusion order',
    'emr_form_oxygen_order': 'Oxygen order',
    'emr_form_physiotherapy_order': 'Physiotherapy order',
    'emr_form_consult_order': 'Consult order',
    'emr_form_vitals_monitoring_order': 'Vitals monitoring order',
    'emr_form_discharge_summary': 'Discharge summary',
    'emr_form_obstetric_history': 'Obstetric history',
    'emr_form_menstrual_history': 'Menstrual history',
    'emr_form_paediatric_history': 'Paediatric history',
    'emr_form_immunisation_status': 'Immunisation status',
    'emr_form_growth_measurement': 'Growth measurement',
    'emr_form_procedure_note': 'Procedure note',
    'emr_form_patient_education': 'Patient education',
    'emr_form_pre_procedure_consent': 'Pre-procedure consent',
    'emr_marker_done': 'Done',
    'emr_marker_required': 'Required',
    'emr_required_x_of_y': '{done} of {total} required done',
    'emr_ready_to_close': 'Ready to close',
    'emr_required_to_close': 'Needed before closing',
    'emr_all_required_done': 'Every required form is filled in',
    'emr_still_needed': 'Still needed',
    'emr_still_needed_hint': 'These forms must be filled in before the consultation can be closed',
    'emr_close_blocked_title': 'Not ready to close',
    'emr_close_blocked_hint': 'Fill in these required forms first',
    'emr_age_days': '{n} d',
    'emr_at_birth': 'At birth',
    'emr_birth_weight_kg': 'Birth weight {kg} kg',
    'emr_gestation_weeks': 'Born at {weeks} weeks',
    'emr_gestation_weeks_days': 'Born at {weeks} weeks {days} days',
    'emr_birth_weight_unknown': 'Birth weight not recorded',
    'emr_gestation_unknown': 'Gestation not recorded',
    'emr_birth_details_missing': 'Add birth details to the patient record',
    'emr_allergy_severity': 'Severity',
    'emr_vitals_not_taken': 'Vitals not taken',
    'emr_vitals_not_taken_title': 'Vitals not taken at this visit',
    'emr_vitals_not_taken_prompt': 'Say why no vitals were taken. The reason stays on the record.',
    'emr_vitals_not_taken_x': 'Vitals not taken: {reason}',
    'emr_vitals_not_taken_clear': 'Undo',
    'emr_not_needed_prescription': 'No medication needed for this visit',
    'emr_not_needed_lab_order': 'No lab tests needed for this visit',
    'emr_not_needed_radiology_order': 'No imaging needed for this visit',
    'emr_not_needed_procedure_order': 'No procedures needed for this visit',
    'emr_not_needed_counts': 'This form is required; marking it not needed counts as done',
    'emr_not_needed_hint': 'Records that you decided nothing was needed',
    'emr_desc_clinical_form': 'Fill in the form and save; each save is kept with its time',
    'emr_form_saved_as_addendum': 'The consultation is closed; a saved form is kept as an addendum',
    'emr_obstetric_in_maternity': 'Record the obstetric history in the antenatal record of the maternity module',
    'emr_form_read_only': 'You can read this form but not fill it in',
    'emr_form_recorded': 'Recorded at this visit',
    'emr_form_recorded_stay': 'Recorded during this stay',
    'emr_form_saved_as_addendum_stay': 'The patient has been discharged; a saved form is kept as an addendum',
    'emr_form_none_recorded': 'Nothing recorded yet',
    'emr_addendum_badge': 'Addendum',
    'dx_find_title': 'Find a diagnosis',
    'dx_find_desc': 'Your favourites, your recent ones and the department\'s common ones, or search ICD-10',
    'dx_lists': 'Diagnosis lists',
    'dx_list_favourites': 'Favourites',
    'dx_list_recent': 'Recent',
    'dx_list_common': 'Common here',
    'dx_hint_favourites': 'Diagnoses you starred',
    'dx_hint_recent': 'Diagnoses you made at your latest visits',
    'dx_hint_common': 'Used most in this department over the last 90 days',
    'dx_empty_favourites': 'Star a diagnosis to keep it here',
    'dx_empty_recent': 'Your recent diagnoses appear here',
    'dx_empty_common': 'Nothing yet for this department',
    'dx_added': 'Added',
    'dx_star': 'Add to favourites',
    'dx_unstar': 'Remove from favourites',
    'dx_star_failed': 'Could not update your favourites',
    'dx_count': '{count, plural, one {# diagnosis} other {# diagnoses}}',
    'dx_primary': 'Primary',
    'dx_primary_toggle': 'Primary diagnosis',
    'dx_remove_x': 'Remove {code}',
    'dx_certainty': 'Certainty',
    'dx_certainty_provisional': 'Provisional',
    'dx_certainty_confirmed': 'Confirmed',
    'dx_certainty_differential': 'Differential',
    'dx_certainty_ruled_out': 'Ruled out',
    'dx_onset_present_on_arrival': 'Present on arrival',
    'dx_onset_new_onset': 'New onset',
    'dx_onset_not_reported': 'Not reported',
    'dx_add_to_problem_list': 'Add to problem list',
    'dx_add_to_problem_list_hint': 'Keeps it on the patient\'s list of long-term conditions',
    'duration_hours': 'Hours',
    'duration_days': 'Days',
    'duration_weeks': 'Weeks',
    'duration_months': 'Months',
    'duration_years': 'Years',
    'ros_finding_normal': 'Normal',
    'ros_finding_abnormal': 'Abnormal',
    'ros_finding_not_examined': 'Not asked',
    'ros_system_constitutional': 'General',
    'ros_system_eyes': 'Eyes',
    'ros_system_ent': 'Ear, nose and throat',
    'ros_system_cardiovascular': 'Heart and circulation',
    'ros_system_respiratory': 'Breathing',
    'ros_system_gastrointestinal': 'Stomach and bowel',
    'ros_system_genitourinary': 'Urinary and genital',
    'ros_system_musculoskeletal': 'Muscles and joints',
    'ros_system_skin': 'Skin',
    'ros_system_neurological': 'Nerves',
    'ros_system_psychiatric': 'Mood and mind',
    'ros_system_endocrine': 'Glands and hormones',
    'care_role_consulting': 'Consulting',
    'care_role_assisting': 'Assisting',
    'care_role_resident': 'Resident',
    'care_role_nurse': 'Nurse',
    'care_role_anaesthetist': 'Anaesthetist',
    'qp_group_label': 'Common phrases',
    'qp_learned_hint': 'One of your most-used phrases',
    'qp_more_x': '{count} more',
    'qp_fever': 'Fever',
    'qp_cough': 'Cough',
    'qp_headache': 'Headache',
    'qp_abdominal_pain': 'Abdominal pain',
    'qp_sore_throat': 'Sore throat',
    'qp_body_aches': 'Body aches',
    'qp_vomiting': 'Vomiting',
    'qp_loose_stools': 'Loose stools',
    'qp_breathlessness': 'Breathlessness',
    'qp_chest_pain': 'Chest pain',
    'qp_sudden_onset': 'Sudden onset',
    'qp_gradual_onset': 'Gradual onset',
    'qp_intermittent': 'Comes and goes',
    'qp_progressively_worse': 'Getting progressively worse',
    'qp_relieved_by_rest': 'Relieved by rest',
    'qp_no_similar_episodes': 'No similar episodes before',
    'qp_no_past_history': 'No significant past history',
    'qp_hypertension': 'Hypertension',
    'qp_diabetes': 'Diabetes mellitus',
    'qp_asthma': 'Asthma',
    'qp_heart_disease': 'Ischaemic heart disease',
    'qp_tb_treated': 'Treated for tuberculosis',
    'qp_no_surgery': 'No previous surgery',
    'qp_appendectomy': 'Appendicectomy',
    'qp_caesarean_section': 'Caesarean section',
    'qp_cholecystectomy': 'Cholecystectomy',
    'qp_no_family_history': 'No significant family history',
    'qp_family_diabetes': 'Diabetes in the family',
    'qp_family_hypertension': 'Hypertension in the family',
    'qp_family_heart_disease': 'Heart disease in the family',
    'qp_non_smoker': 'Non-smoker',
    'qp_smoker': 'Smoker',
    'qp_no_alcohol': 'No alcohol use',
    'qp_lives_with_family': 'Lives with family',
    'qp_no_regular_medicines': 'No regular medicines',
    'qp_on_antihypertensives': 'Takes blood pressure medicines',
    'qp_on_diabetes_medicines': 'Takes diabetes medicines',
    'qp_on_inhalers': 'Uses inhalers',
    'qp_no_other_complaints': 'No other complaints',
    'qp_no_weight_loss': 'No weight loss',
    'qp_no_night_sweats': 'No night sweats',
    'qp_no_chest_pain': 'No chest pain',
    'qp_no_breathlessness': 'No breathlessness',
    'qp_conscious_oriented': 'Conscious and oriented',
    'qp_no_pallor_jaundice': 'No pallor or jaundice',
    'qp_chest_clear': 'Chest clear',
    'qp_heart_sounds_normal': 'Heart sounds normal',
    'qp_abdomen_soft': 'Abdomen soft and non-tender',
    'qp_no_focal_deficit': 'No focal neurological deficit',
    'qp_throat_congested': 'Throat congested',
    'qp_symptomatic_treatment': 'Symptomatic treatment',
    'qp_review_with_reports': 'Review with reports',
    'qp_continue_medicines': 'Continue current medicines',
    'qp_refer_specialist': 'Refer to a specialist',
    'qp_admit_observation': 'Admit for observation',
    'qp_plenty_of_fluids': 'Plenty of oral fluids',
    'qp_rest_3_days': 'Rest for 3 days',
    'qp_return_if_worse': 'Come back if symptoms get worse',
    'qp_medicines_after_meals': 'Take medicines after meals',
    'qp_avoid_oily_food': 'Avoid oily and spicy food',
    'qp_follow_up_one_week': 'Follow up in one week',
    'cf_gravida': 'Gravida',
    'cf_para': 'Para',
    'cf_abortions': 'Abortions',
    'cf_living_children': 'Living children',
    'cf_lmp': 'Last menstrual period',
    'cf_edd': 'Expected delivery',
    'cf_cycle_days': 'Cycle (days)',
    'cf_menarche_age': 'Age at menarche',
    'cf_flow_days': 'Flow (days)',
    'cf_regular': 'Regular cycle',
    'cf_menopause': 'Menopause',
    'cf_birth_weight_kg': 'Birth weight (kg)',
    'cf_gestation_weeks': 'Gestation (weeks)',
    'cf_delivery': 'Delivery',
    'cf_feeding': 'Feeding',
    'cf_milestones': 'Milestones',
    'cf_vaccines_given': 'Vaccines given (e.g. BCG, OPV-1)',
    'cf_measured_on': 'Measured on',
    'cf_procedure': 'Procedure',
    'cf_indication': 'Indication',
    'cf_anaesthesia': 'Anaesthesia',
    'cf_complications': 'Complications',
    'cf_performed_by': 'Performed by',
    'cf_topics': 'Topics',
    'cf_method': 'Method',
    'cf_understood': 'Patient understood',
    'cf_risks_explained': 'Risks explained',
    'cf_signed_by': 'Signed by',
    'cf_relation': 'Relation',
    'cf_witness': 'Witness',
    'cf_opt_normal': 'Normal delivery',
    'cf_opt_caesarean': 'Caesarean',
    'cf_opt_assisted': 'Assisted',
    'cf_opt_breast': 'Breast milk',
    'cf_opt_formula': 'Formula',
    'cf_opt_mixed': 'Mixed',
    'cf_opt_family_food': 'Family food',
    'cf_opt_on_time': 'On time',
    'cf_opt_delayed': 'Delayed',
    'cf_opt_not_assessed': 'Not assessed',
    'cf_opt_none': 'None',
    'cf_opt_local': 'Local',
    'cf_opt_sedation': 'Sedation',
    'cf_opt_regional': 'Regional',
    'cf_opt_general': 'General',
    'cf_opt_verbal': 'Spoken',
    'cf_opt_leaflet': 'Leaflet',
    'cf_opt_demonstration': 'Demonstration',
    'cf_opt_video': 'Video',
    'cf_opt_self': 'Self',
    'cf_opt_parent': 'Parent',
    'cf_opt_spouse': 'Spouse',
    'cf_opt_guardian': 'Guardian',
    'cf_opt_other': 'Other',
    'emr_more_actions': 'More',
    'emr_could_not_print': 'Could not print',
    'emr_waiver_prompt': 'Why should the fee be waived? The cash counter sees this.',
    'send_waiver_request': 'Send request',
    'outpatient_billing': 'Outpatient billing',
    'patients_pay_the_visit_bill_on_arrival': 'Patients pay the visit bill when they arrive. The doctor can start the consultation and open the patient record only after it is paid; a supervisor can override with a written reason.',
    'no_show_keep_the_fee': 'Keep the fee',
    'no_show_flag_for_refund': 'Flag for refund',
    'the_clinic_day_closes_at_hour_0_8': 'The clinic day closes at (hour, 0–8)',
    'evening_sessions_that_run_past_midnight_belong': 'Evening sessions that run past midnight belong to the day they started, until this hour',
    'late_entry_allowed_for_days': 'Late entry allowed for (days)',
    'visits_of_earlier_days_can_be_entered_by_staff': 'Visits of earlier days can be entered by staff allowed to back-date, with a reason',
    'patient_screening_at_the_nurse_station': 'Patient screening at the nurse station',
    'who_is_called_next': 'Who is called next',
    'online_bookings_per_patient': 'Online bookings per patient',
    'upcoming_appointments_a_patient_may_hold': 'Upcoming appointments a patient may hold through the portal',
    'close_each_clinic_day_mark_patients_who_never': 'Close each clinic day: mark patients who never came, or left without being seen, as not attended',
    'the_doctor_may_start_a_booked_patient_who_was': 'The doctor may start a booked patient who was not checked in at the desk (the arrival is recorded first)',
    'take_walk_ins_for_a_doctor_who_has_no_clinic': 'Take walk-ins for a doctor who has no clinic session at the time',
    'a_consultation_needs_a_principal_diagnosis': 'A consultation needs a principal diagnosis before it is closed',
    'could_not_open_the_consultation': 'Could not open the consultation',
    'could_not_call_the_patient': 'Could not call the patient',
    'next_patient_called': 'Next patient called',
    'nobody_to_call': 'Nobody to call',
    'queue': 'Queue',
    'patients_who_have_arrived_in_the_order_they': 'Patients who have arrived, in the order they were seen at the desk',
    'all_doctors': 'All doctors',
    'call_next': 'Call next',
    'nobody_is_waiting_patients_appear_here_once': 'Nobody is waiting. Patients appear here once reception marks them as arrived.',
    'waiting': 'Waiting',
    'min': 'min',
    'ready': 'Ready',
    'vitals': 'vitals',
    'no_vitals': 'no vitals',
    'no_fee_set_for_this_doctor_tell_the_billing': 'No fee set for this doctor — tell the billing office',
    'fee_paid': 'fee paid',
    'fee_due': 'fee due',
    'set_fee': 'set fee',
    'abnormal_vitals': 'abnormal vitals',
    'mark_arrived': 'Mark arrived',
    'arrive_this_booking': 'Arrive this booking',
    'mark_no_show': 'Mark no-show',
    'mark_left_without_being_seen': 'Mark left without being seen',
    'no_show_money_effect': 'An unpaid fee bill on this visit is cancelled. A fee already paid is flagged for a refund, or kept if the hospital keeps paid no-show fees.',
    'vitals_2': 'Vitals',
    'call_again': 'Call again',
    'call': 'Call',
    'resume': 'Resume',
    'start': 'Start',
    'fee_not_paid_yet': 'Fee not paid yet',
    'late_entry_of_an_earlier_visit': 'Late entry of an earlier visit',
    'start_anyway': 'Start anyway',
    'x_has_not_paid_the_consultation_fee_collect_it': '{patientName} has not paid the consultation fee. Collect it at the counter, or start with a reason.',
    'consultation_fee_not_billed_yet': 'Consultation fee not billed yet',
    'the_first_order_bills_the_consultation_fee': 'The first test, imaging or procedure ordered here bills it automatically. If it cannot be billed, the order is refused — ask the counter to settle the fee first.',
    'open_the_statement': 'Open the statement',
    'this_visit_was_on_an_earlier_clinic_day_it_is': 'This visit was on an earlier clinic day. It is entered without a token; say why it is being entered late.',
    'set_saved': 'Set saved',
    'load_a_prescription_set': 'Load a prescription set',
    'load_set': 'Load set…',
    'save_as_set': 'Save as set',
    'save_as_a_prescription_set': 'Save as a prescription set',
    'leave_removed': 'Leave removed',
    'could_not_remove_the_leave': 'Could not remove the leave',
    'clinic_hours_removed': 'Clinic hours removed',
    'could_not_remove_this_schedule': 'Could not remove this schedule',
    'clinic_hours': 'Clinic hours',
    'weekly_templates_that_generate_the_bookable': 'Weekly templates that generate the bookable slots, plus leave that takes them away',
    'mark_leave': 'Mark leave',
    'schedule_not_found': 'That schedule could not be opened.',
    'not_in_the_queue': 'This patient is no longer waiting in the triage queue.',
    'pain': 'Pain',
    'pregnancy': 'Pregnancy',
    'certificate_text': 'Certificate text',
    'consent': 'Consent',
    'arrival': 'Arrival',
    'medico_legal': 'Medico-legal',
    'outcome': 'Outcome',
    'er_board_title': 'Emergency board',
    'er_board_description': 'Sickest first, then longest waiting',
    'er_register_arrival': 'Register arrival',
    'er_door_to_doctor_recorded': 'Door-to-doctor recorded',
    'er_could_not_record_it': 'Could not record it',
    'er_in_the_department': 'In the department',
    'er_awaiting_triage': 'Awaiting triage',
    'er_awaiting_doctor': 'Awaiting doctor',
    'er_longest_wait': 'Longest wait',
    'er_untriaged_arrivals': '{count, plural, one {# arrival has} other {# arrivals have}} not been triaged',
    'er_board_truncated': 'Showing the first {limit} open cases, sickest first. More are waiting behind them.',
    'er_department_empty': 'The department is empty.',
    'er_bay': 'Bay',
    'er_unidentified': 'Unidentified',
    'er_mlc': 'MLC',
    'er_not_identified': 'Not identified',
    'er_dispose': 'Dispose',
    'er_recorded_x': 'Recorded {time}',
    'er_recorded_x_abnormal': 'Recorded {time} — outside the normal range',
    'er_born_x': 'born {date}',
    'er_about_x_years': 'about {years} y',
    'er_age_unknown': 'age unknown',
    'er_could_not_print_the_summary': 'Could not print the summary',
    'er_could_not_issue_the_death_certificate': 'Could not issue the death certificate',
    'er_emergency_case': 'Emergency case',
    'er_emergency_case_x': 'Emergency case {number}',
    'er_unidentified_arrival': 'Unidentified arrival',
    'er_issue_and_print_death_certificate': 'Issue and print death certificate',
    'er_print_summary': 'Print summary',
    'er_deceased': 'Deceased',
    'er_no_complaint_recorded': 'No complaint recorded',
    'er_brought_by_x': 'brought by {name}',
    'er_brought_by_x_phone': 'brought by {name} ({phone})',
    'er_bay_x': 'Bay {bay}',
    'er_no_bay': 'No bay',
    'er_triaged_x': 'triaged {time}',
    'er_not_yet_seen': 'Not yet seen',
    'er_seen_x': 'Seen {time}',
    'er_time_in_the_department': 'Time in the department',
    'er_referred_to_x': 'Referred to {place}',
    'er_still_in_the_department': 'Still in the department',
    'er_death_recorded': 'Death recorded',
    'er_registration_invoice': 'Registration invoice',
    'er_triage_notes': 'Triage notes',
    'er_edit_mlc_flag': 'Edit MLC flag',
    'er_no_details_recorded': 'No details recorded',
    'er_not_a_medico_legal_case': 'Not recorded as a medico-legal case.',
    'er_vital_signs': 'Vital signs',
    'er_no_vitals_since_arrival': 'No vital signs recorded since the arrival.',
    'er_vitals_after_identification': 'Vital signs are kept on the patient record, so they appear once the patient is identified.',
    'er_recorded': 'Recorded',
    'er_resp': 'Resp',
    'er_no_orders_since_arrival': 'No orders raised since the arrival.',
    'er_ordered': 'Ordered',
    'er_items': 'Items',
    'er_mlc_flag_updated': 'Medico-legal flag updated',
    'er_mlc_change_audited': 'The change and its reason are in the audit trail',
    'er_medico_legal_case': 'Medico-legal case',
    'er_mlc_details': 'MLC details',
    'er_mlc_details_hint': 'Police station, FIR number, nature of the incident',
    'er_reason_for_the_change': 'Reason for the change',
    'er_mlc_reason_hint': 'Only a doctor can change this flag; the reason is kept in the audit trail',
    'er_save_flag': 'Save flag',
    'er_temporary_patient_registered': 'Temporary patient registered',
    'er_temporary_patient_registered_detail': 'Tests and imaging can be ordered now; merge the record once the identity is known',
    'er_patient_identified': 'Patient identified',
    'er_death_now_on_record': 'The death is now on their record',
    'er_case_linked_to_record': 'The case is linked to their record',
    'er_identify_the_patient': 'Identify the patient',
    'er_identify_death_warning': 'This person died in the department. Linking a patient record puts the death on it, so a doctor must confirm the identity and say how it was established. It is refused for anyone who was seen, billed or booked since the arrival.',
    'er_identify_link_hint': 'Link this arrival to their patient record. Vital signs and orders follow the record from then on.',
    'er_confirmed_person_who_died': 'I have confirmed this is the person who died',
    'er_identity_basis': 'How was the identity established',
    'er_identity_basis_hint': 'For example: identity card checked, identified by a named relative',
    'er_identify_patient': 'Identify patient',
    'er_temporary_patient_hint': 'No record yet and the patient cannot be identified? Register a temporary patient under the ER label so tests and imaging can be ordered now.',
    'er_estimated_age': 'Estimated age',
    'er_register_temporary_patient': 'Register temporary patient',
    'publish_schedule': 'Publish schedule',
    'weekly_hours': 'Weekly hours',
    'leave_and_blocks': 'Leave & blocks',
    'no_clinic_hours_published_yet_until_a_doctor': 'No clinic hours published yet. Until a doctor has a weekly template, the booking screen has no slots to offer.',
    'branch': 'Branch',
    'effective': 'Effective',
    'open': 'open',
    'edit': 'Edit',
    'remove_clinic_hours': 'Remove clinic hours',
    'remove_clinic_hours_effect': 'These hours end today and stay on past visits. If an upcoming appointment is covered only by these hours, cancel or move it first.',
    'no_leave_recorded_slots_inside_a_leave_block': 'No leave recorded. Slots inside a leave block stop being bookable.',
    'to': 'To',
    'notes': 'Notes',
    'remove_leave': 'Remove leave',
    'clinic_hours_published': 'Clinic hours published',
    'the_booking_screen_can_now_offer_these_slots': 'The booking screen can now offer these slots.',
    'some_booked_appointments_no_longer_fit': 'Some booked appointments no longer fit',
    'the_new_hours_are_published_these_bookings_were': 'The new hours are published. These bookings were made under the old hours and were left as they are.',
    'booking_s_fall_outside_the_new_hours_call_each': 'booking(s) fall outside the new hours. Call each patient, then move or cancel the appointment from the Appointments screen.',
    'edit_clinic_hours_x': 'Edit clinic hours — {name}',
    'publish_clinic_hours': 'Publish clinic hours',
    'a_weekly_template_saving_supersedes_the_doctors': 'A weekly template. Saving supersedes the doctor\'s current template at this branch — booked appointments keep their times.',
    'publish': 'Publish',
    'select_a_branch': 'Select a branch',
    'department': 'Department',
    'narrows_the_doctor_list_below': 'Narrows the doctor list below',
    'all_departments': 'All departments',
    'locked_while_editing_start_a_new_schedule_to': 'Locked while editing — start a new schedule to move it to another doctor',
    'effective_from': 'Effective from',
    'effective_to': 'Effective to',
    'leave_blank_for_an_open_ended_schedule': 'Leave blank for an open-ended schedule',
    'slot_length': 'Slot length',
    'set_for_each_session_below': 'Set for each session below',
    'per_session': 'Per session',
    'add_a_session': 'Add a session',
    'day': 'Day',
    'session_x_starts': 'Session {value} starts',
    'session_x_ends': 'Session {value} ends',
    'overbook': 'Overbook',
    'remove_session': 'Remove session',
    'slot_min': 'Slot (min)',
    'per_slot': 'Per slot',
    'walk_in_seats': 'Walk-in seats',
    '0_no_limit': '0: no limit',
    'room': 'Room',
    'portal_limit': 'Portal limit',
    'blank_none': 'Blank: none',
    'bookable_online': 'Bookable online',
    'a_session_must_end_after_it_starts_an_evening': 'A session must end after it starts. An evening session may run past midnight, up to the hour the clinic day closes (set under Settings, Clinical).',
    'leave_recorded': 'Leave recorded',
    'slots_in_this_window_are_no_longer_bookable': 'Slots in this window are no longer bookable.',
    'blocks_out_a_window_without_touching_the_weekly': 'Blocks out a window without touching the weekly template',
    'booking_s_fall_inside_this_window_after_saving': 'booking(s) fall inside this window. After saving you can move them.',
    'leave': 'Leave',
    'conference': 'Conference',
    'surgery': 'Surgery',
    'could_not_change_the_hand_off': 'Could not change the hand-off',
    'could_not_change_the_priority': 'Could not change the priority',
    'token_x_called': 'Token {tokenNo} called',
    'triage': 'Triage',
    'vitals_screening_and_hand_off_to_the_doctor': 'Vitals, screening and hand-off to the doctor',
    'nobody_is_waiting_for_triage': 'Nobody is waiting for triage.',
    'stage': 'Stage',
    'ready_2': 'ready',
    'called': 'called',
    'screened': 'screened',
    'not_screened': 'not screened',
    'screening': 'Screening',
    'not_ready': 'Not ready',
    'screening_recorded': 'Screening recorded',
    'nursing_screening': 'Nursing screening',
    'pain_score_0_10': 'Pain score (0–10)',
    'where': 'Where',
    'fall_risk': 'Fall risk',
    'nutrition': 'Nutrition',
    'lost_weight_without_trying': 'Lost weight without trying',
    'eating_less_than_usual': 'Eating less than usual',
    'could_she_be_pregnant': 'Could she be pregnant?',
    'not_asked_2': 'Not asked',
    'no': 'No',
    'possibly': 'Possibly',
    'yes': 'Yes',
    'does_not_know': 'Does not know',
    'attached': 'Attached',
    'could_not_attach_the_file': 'Could not attach the file',
    'could_not_withdraw_the_file': 'Could not withdraw the file',
    'withdraw_file_title': 'Withdraw {title}',
    'withdraw_file_description': 'Why is this file being withdrawn? It stays on the record, marked as withdrawn.',
    'withdrawn_reason': 'withdrawn: {reason}',
    'title': 'Title',
    'ecg_outside_report': 'ECG, outside report…',
    'add_file_or_photo': 'Add file or photo',
    'no_files_attached': 'No files attached.',
    'kb': 'KB',
    'open_2': 'Open',
    'form_saved': 'Form saved',
    'could_not_save_the_form': 'Could not save the form',
    'record_in_the_antenatal_record': ': record in the antenatal record',
    'addendum': 'addendum',
    'separate_items_with_commas': 'Separate items with commas',
    'could_not_add_the_colleague': 'Could not add the colleague',
    'could_not_remove_the_colleague': 'Could not remove the colleague',
    'care_team': 'Care team',
    'only_the_treating_doctor': 'Only the treating doctor.',
    'colleague': 'Colleague',
    'add_a_colleague': 'Add a colleague…',
    'role': 'Role',
    'sent_now_token_x': 'Sent now — token {tokenNo}',
    'referral_recorded': 'Referral recorded',
    'could_not_record_the_referral': 'Could not record the referral',
    'admission_requested': 'Admission requested',
    'the_ward_sees_it_under_admissions': 'The ward sees it under Admissions',
    'could_not_request_admission': 'Could not request admission',
    'procedure_ordered_and_added_to_the_bill': 'Procedure ordered and added to the bill',
    'could_not_order_the_procedure': 'Could not order the procedure',
    'could_not_record_the_procedure': 'Could not record the procedure',
    'procedure_note_title': 'Record the procedure',
    'procedure_note_description': 'What was done, the findings, and any complication.',
    'procedure_note': 'Procedure note',
    'no_referral_admission_request_or_procedure_for': 'No referral, admission request or procedure for this visit.',
    'order': 'Order',
    'when': 'When',
    'letter': 'Letter',
    'refer': 'Refer',
    'to_a_colleague_here': 'To a colleague here',
    'to_another_hospital_or_specialist': 'To another hospital or specialist',
    'any_in_the_department': 'Any in the department',
    'refer_to': 'Refer to',
    'speciality': 'Speciality',
    'urgency': 'Urgency',
    'send_now_put_the_patient_in_the_colleagues': 'Send now: put the patient in the colleague\'s queue today',
    'admission': 'Admission',
    'advise_admission': 'Advise admission',
    'ward_class': 'Ward class',
    'any': 'Any',
    'expected_stay_days': 'Expected stay (days)',
    'request_admission': 'Request admission',
    'this_hospital_has_no_wards_here_refer_the': 'This hospital has no wards here. Refer the patient to another hospital and choose "Referred elsewhere" when closing; the referral letter prints.',
    'procedure': 'Procedure',
    'could_not_close_the_referral': 'Could not close the referral',
    'referred_to_me': 'Referred to me',
    'referrals_to_book': 'Referrals to book',
    'requests_made_before': 'Requests made before',
    'that_never_reached_the_lab': 'that never reached the lab',
    'these_were_entered_as_medicine_orders_and_never': 'These were entered as medicine orders and never reached the lab or radiology. Re-order them here, or dismiss them.',
    're_order': 'Re-order',
    'dismiss': 'Dismiss',
    'investigations': 'Investigations',
    'loading': 'Loading…',
    'nothing_ordered_yet': 'Nothing ordered yet.',
    'outside_requisition': 'Outside requisition',
    'rejected_recollect': 'Rejected — recollect',
    'load_more': 'Load more',
    'cumulative_results_verified': 'Cumulative results (verified)',
    'test': 'Test',
    'written_as_an_outside_requisition_it_prints': 'Written as an outside requisition — it prints under "Investigations advised"',
    'tests_ordered_the_lab_has_them_on_its_worklist': 'Tests ordered — the lab has them on its worklist',
    'imaging_ordered_radiology_has_it_on_the_worklist': 'Imaging ordered — radiology has it on the worklist',
    'kind_of_investigation': 'Kind of investigation',
    'urgent': 'Urgent',
    'stat': 'STAT',
    'this_hospital_does_not_run': 'This hospital does not run',
    'a_laboratory': 'a laboratory',
    'imaging_3': 'imaging',
    'here_write_what_the_patient_should_have_done': 'here. Write what the patient should have done elsewhere; it prints under “Investigations advised” and raises no bill.',
    'outside_investigations': 'Outside investigations',
    'one_per_line': 'One per line',
    'serum_ferritin_vitamin_d': 'Serum ferritin\nVitamin D',
    'mri_knee_right': 'MRI knee (right)',
    'tests_and_panels': 'Tests and panels',
    'studies': 'Studies',
    'search_then_click_to_add': 'Search, then click to add',
    'cbc_hba1c_lipid_profile': 'CBC, HbA1c, lipid profile…',
    'chest_x_ray_ultrasound_abdomen': 'Chest X-ray, ultrasound abdomen…',
    'nothing_matches': 'Nothing matches.',
    'back_to_our_catalogue': 'Back to our catalogue',
    'not_in_our_catalogue_write_as_outside_test': 'Not in our catalogue — write as outside test',
    'remove_x': 'Remove {name}',
    'collect_at': 'Collect at',
    'leave_empty_to_collect_now_e_g_fasting_sugar': 'Leave empty to collect now, e.g. fasting sugar tomorrow 06:00',
    'could_the_patient_be_pregnant_x_ray_ct_and': 'Could the patient be pregnant? (X-ray, CT and similar studies use radiation)',
    'not_pregnant': 'Not pregnant',
    'pregnant_proceed': 'Pregnant — proceed',
    'why_the_study_goes_ahead': 'Why the study goes ahead',
    'clinical_notes_for_the_lab_radiologist': 'Clinical notes for the lab / radiologist',
    'write_outside_requisition': 'Write outside requisition',
    'why_is_there_no_document': 'Why is there no document?',
    'choose_a_reason_2': 'Choose a reason…',
    'document': 'Document',
    'id_number': 'ID number',
    'for_example_x': 'For example {example}',
    'issuing_country': 'Issuing country',
    'choose_2': 'Choose…',
    'passport_expiry': 'Passport expiry',
    'nationality': 'Nationality',
    'occupation_code': 'Occupation code',
    'the_occupation_the_insurer_records_for_nphies': 'The occupation the insurer records, for NPHIES',
    'use_the_usual_document': 'Use the usual document',
    'other_document_passport': 'Other document / passport',
    'no_document': 'No document',
    'id_mode_usual': 'Usual document',
    'id_mode_other': 'Passport / other',
    'document_type': 'Document type',
    'id_missing_unidentified': 'Unidentified — brought in, identity unknown',
    'id_missing_newborn': 'Newborn',
    'id_missing_not_held': 'Does not hold a document',
    'id_missing_refused': 'Declined to show one',
    'say_why_the_patient_has_no_document': 'Say why the patient has no document',
    'record_an_identity_document_or_no_document': 'Record an identity document, or choose No document with a reason',
    'remove_number_needs_no_document': 'To remove the ID number, choose No document and give a reason',
    'no_document_needs_reason': 'Say why the patient has no document',
    'that_hijri_date_does_not_exist': 'That Hijri date does not exist',
    'date_of_birth_hijri': 'Date of birth (Hijri)',
    'gregorian_x': 'Gregorian {value}',
    'day_month_year_umm_al_qura': 'Day, month, year (Umm al-Qura)',
    'month': 'Month',
    'year': 'Year',
    'primary_guardian_changed': 'Primary guardian changed',
    'could_not_change_the_primary_guardian': 'Could not change the primary guardian',
    'contact_removed': 'Contact removed',
    'could_not_remove_the_contact': 'Could not remove the contact',
    'no_guardian_or_contact_on_record': 'No guardian or contact on record.',
    'make_primary': 'make primary',
    'remove_2': 'remove',
    'add_guardian_contact': 'Add guardian / contact',
    'add_a_guardian_or_contact': 'Add a guardian or contact',
    'a_second_parent_an_attendant_or_whoever_may': 'A second parent, an attendant, or whoever may consent on the patient\'s behalf',
    'save_contact': 'Save contact',
    'relation': 'Relation',
    'phone': 'Phone',
    '03xxxxxxxxx': '03xxxxxxxxx',
    'may_consent_for_the_patient': 'May consent for the patient',
    'make_this_the_primary_guardian': 'Make this the primary guardian',
    'could_not_print_the_card': 'Could not print the card',
    'loading_the_record': 'Loading the record…',
    'that_patient_record_could_not_be_opened': 'That patient record could not be opened.',
    'x_x_x_registered_x': '{mrn} · {ageLabel} · {sex} · registered {createdAt}',
    'patient_card': 'Patient card',
    'recorded_as_deceased': 'Recorded as deceased',
    'the_record_is_read_only': '. The record is read-only.',
    'undo_patient_is_alive': 'Undo — patient is alive',
    'details': 'Details',
    'category': 'Category',
    'blood_group': 'Blood group',
    'date_of_birth': 'Date of birth',
    'address': 'Address',
    'guardians_and_contacts': 'Guardians & contacts',
    'coverage': 'Coverage',
    'record_allergy': 'Record allergy',
    'clinical_timeline': 'Clinical timeline',
    'billing': 'Billing',
    'insurance': 'Insurance',
    'documents_and_consents': 'Documents & consents',
    'loading_history': 'Loading history…',
    'by': 'By',
    'no_clinical_history_yet': 'No clinical history yet.',
    'your_role_does_not_include_access_to_clinical': 'Your role does not include access to clinical records.',
    'statement_of_account': 'Statement of account',
    'no_invoices_for_this_patient': 'No invoices for this patient.',
    'invoice': 'Invoice',
    'context': 'Context',
    'total': 'Total',
    'balance': 'Balance',
    'your_role_does_not_include_billing_access': 'Your role does not include billing access.',
    'consents': 'Consents',
    'no_consents_recorded': 'No consents recorded.',
    'documents': 'Documents',
    'no_documents_uploaded': 'No documents uploaded.',
    'the_patient_record_is_open_again': 'The patient record is open again',
    'patient_is_alive': 'Patient is alive',
    'x_was_recorded_as_deceased_by_mistake': '{patientName} was recorded as deceased by mistake',
    'undo_the_death_record': 'Undo the death record',
    'this_reopens_the_patient_record_and_voids_any': 'This reopens the patient record and voids any death certificate issued for it. The reason is kept in the audit trail.',
    'at_least_5_characters_what_was_wrong_with_the': 'At least 5 characters. What was wrong with the death record?',
    'allergy_recorded': 'Allergy recorded',
    'prescribing_will_now_warn_on_this_substance': 'Prescribing will now warn on this substance',
    'could_not_record_the_allergy': 'Could not record the allergy',
    'record_an_allergy': 'Record an allergy',
    'this_warns_every_prescriber_from_now_on': 'This warns every prescriber from now on',
    'a_class_name_such_as_penicillin_also_catches': 'A class name such as \'penicillin\' also catches its members',
    'rash_anaphylaxis': 'Rash, anaphylaxis…',
    'severity': 'Severity',
    'mild': 'Mild',
    'moderate': 'Moderate',
    'severe': 'Severe',
    'clear_patient': 'Clear patient',
    'mrn_name_phone_or_x': 'MRN, name, phone or {label}',
    'searching': 'Searching…',
    'no_patient_matches_that': 'No patient matches that.',
    'taken_on': 'Taken on',
    'mrn_x_no_need_to_register_them_again': 'MRN {mrn} — no need to register them again',
    'patient_registered': 'Patient registered',
    'mrn_x': 'MRN {mrn}',
    'please_check': 'Please check',
    'register_patient': 'Register patient',
    'one_lifetime_record_per_person_on_the_platform': 'One lifetime record per person, on the platform',
    'a_name_and_a_mobile_number_is_all_this_counter': 'A name and a mobile number is all this counter needs — the platform keeps the rest',
    'identity': 'Identity',
    'first_name': 'First name',
    'name_in_arabic': 'Name in Arabic',
    'add_the_name_in_arabic': 'Add the name in Arabic',
    'enter_the_gregorian_date_instead': 'Enter the Gregorian date instead',
    'enter_the_date_in_hijri': 'Enter the date in Hijri',
    'or_give_an_approximate_age': 'Or give an approximate age',
    'approximate_age_years': 'Approximate age (years)',
    'contact': 'Contact',
    'alternate_phone': 'Alternate phone',
    'email': 'Email',
    'city': 'City',
    'guardian_and_emergency_contact': 'Guardian and emergency contact',
    'relation_to_patient': 'Relation to patient',
    'self_the_patient_manages_their_own_visits': 'Self — the patient manages their own visits. Otherwise, who is responsible for them: their parent, their child, and so on.',
    'guardian_name': 'Guardian name',
    'guardian_phone': 'Guardian phone',
    'emergency_contact_name': 'Emergency contact name',
    'emergency_contact_phone': 'Emergency contact phone',
    'registration': 'Registration',
    'drives_which_tariff_prices_the_visit': 'Drives which tariff prices the visit',
    'preferred_language': 'Preferred language',
    'possible_existing_records': 'Possible existing records',
    'duplicate_sheet_kept': 'What you typed on the form is kept while you check this record.',
    'duplicate_sheet_unavailable': 'This record could not be loaded.',
    'matched_on_x': 'Matched on {fields}',
    'back_to_the_form': 'Back to the form',
    'open_this_record': 'Open this record',
    'this_is_a_different_person_register_anyway': 'This is a different person — register anyway',
    'register_and_allocate_mrn': 'Register and allocate MRN',
    'register_quick_submit': 'Register now',
    'registration_mode': 'Registration mode',
    'registration_mode_quick': 'Quick registration',
    'registration_mode_quick_hint': 'Name, phone, sex and age — for walk-ins and emergencies',
    'registration_mode_full': 'Full registration',
    'registration_mode_full_hint': 'Every section, for a complete record',
    'quick_mode_note': 'Quick registration saves the essentials now. Complete the rest later from the patient’s profile.',
    'full_mode_note': 'Fill in what the patient can tell you — only the marked fields are required.',
    'quick_mode_footer': 'Saved as a quick registration — complete it later from the profile.',
    'registering_at': 'Registering at',
    'section_identity_document': 'Identity document',
    'section_identity_document_hint': 'First, because the number finds earlier records and fills in details',
    'section_patient': 'Patient',
    'section_patient_hint': 'The minimum needed to open a record',
    'section_personal_details': 'Personal details',
    'section_personal_details_hint': 'Name as on the document, sex and age',
    'section_birth_details': 'Birth details',
    'section_birth_details_hint': 'Birth weight and gestation guide dosing and growth for babies',
    'section_contact_address': 'Contact & address',
    'section_contact_address_hint': 'How to reach the patient and where they live',
    'section_guardian': 'Guardian / next of kin',
    'section_guardian_hint': 'Who is responsible for the patient, if not themselves',
    'section_guardian_minor_hint': 'A patient under 18 needs a guardian who can consent for them',
    'section_emergency_contact': 'Emergency contact',
    'section_emergency_contact_hint': 'Who to call if something happens during the visit',
    'section_payer': 'Billing & preferences',
    'section_payer_hint': 'Who pays, and the language the patient prefers',
    'section_complete': 'Section complete',
    'section_incomplete': 'Section not complete yet',
    'required_for_adults': 'Required for adults',
    'required_under_18': 'Required under 18',
    'minor': 'Minor',
    'infant': 'Infant',
    'estimated': 'Estimated',
    'or': 'or',
    'age': 'Age',
    'age_in_years': 'Age in years',
    'years_short': 'years',
    'dob_or_age_hint': 'Type the date as DD/MM/YYYY, or just the age in years.',
    'dob_or_age_empty': 'Date of birth or age',
    'age_days_old': '{count, plural, one {# day old} other {# days old}}',
    'age_months_old': '{count, plural, one {# month old} other {# months old}}',
    'age_years_old': '{count, plural, one {# year old} other {# years old}}',
    'age_about_years': '{count, plural, one {About # year old} other {About # years old}}',
    'mobile_number': 'Mobile number',
    'marital_status': 'Marital status',
    'marital_single': 'Single',
    'marital_married': 'Married',
    'marital_widowed': 'Widowed',
    'marital_divorced': 'Divorced',
    'marital_unknown': 'Not stated',
    'guardian_relation_self': 'Self',
    'guardian_relation_other': 'Someone else',
    'guardian_relation_needed_for_minor': 'A patient under 18 needs a guardian — pick their relation to the patient',
    'guardian_needed_for_minor': 'A patient under 18 needs a guardian',
    'guardian_name_or_self': 'Name the guardian, or set the relation to Self',
    'guardian_phone_needed': 'A guardian phone number is needed',
    'guardian_from_linked_patient': 'Left blank, the linked relative is recorded as the guardian.',
    'insurance_added_on_profile': 'Insurance policies are added on the patient’s Insurance tab once they are registered.',
    'birth_weight': 'Birth weight',
    'birth_weight_hint': 'In grams, as weighed at birth',
    'birth_weight_range': 'Enter a birth weight between {min} and {max} grams',
    'birth_weight_value': '{grams, number} grams',
    'grams_unit': 'grams',
    'gestational_age': 'Gestational age at birth',
    'gestational_age_hint': 'Completed weeks, plus extra days if known',
    'gestational_weeks_range': 'Enter between {min} and {max} weeks',
    'gestational_days_range': 'Extra days run from 0 to {max}',
    'gestational_extra_days': 'Extra days',
    'gestation_value': '{weeks}+{days} weeks',
    'weeks_unit': 'weeks',
    'days_unit': 'days',
    'birth_weight_band_extremely_low': 'Extremely low birth weight',
    'birth_weight_band_very_low': 'Very low birth weight',
    'birth_weight_band_low': 'Low birth weight',
    'birth_weight_band_normal': 'Normal birth weight',
    'birth_weight_band_high': 'High birth weight',
    'gestation_band_preterm': 'Preterm',
    'gestation_band_term': 'Term',
    'gestation_band_post_term': 'Post-term',
    'platform_match_title': 'This number is already on the platform',
    'platform_match_hint': 'Use the details already recorded, or take the person on without typing them again.',
    'use_these_details': 'Use these details',
    'summary_card_label': 'Patient being registered',
    'new_patient': 'New patient',
    'mrn_on_save': 'MRN allocated on save',
    'record_completeness': 'Record completeness',
    'record_completeness_hint': 'Open sections are fine — fill them in when you can.',
    'record_completeness_done': 'Every section is filled in.',
    'duplicates_checked_as_you_type': 'Checked as you type the name, phone, date of birth and ID number.',
    'no_matching_records_so_far': 'No matching records so far.',
    'duplicates_found_hint': 'Open one to compare before creating a second record.',
    'duplicates_found_count': '{count, plural, one {# possible existing record — review it} other {# possible existing records — review them}}',
    'match_name': 'Name',
    'match_phone': 'Phone',
    'match_id_number': 'ID number',
    'match_date_of_birth': 'Date of birth',
    'print_patient_card': 'Print patient card',
    'success_print_hint': 'The card with the MRN and a QR code',
    'success_book_hint': 'Pick a doctor and a time',
    'success_walk_in_hint': 'Send them to the queue now',
    'success_profile_hint': 'History, documents and billing',
    'open_profile': 'Open profile',
    'register_another_patient': 'Register another patient',
    'copy_mrn': 'Copy MRN',
    'mrn_copied': 'MRN copied',
    'mrn_copy_failed': 'Could not copy the MRN',
    'quick_saved_title': 'Saved with the essentials',
    'quick_saved_body': 'Add the identity, address, guardian and emergency details when there is time.',
    'quick_saved_body_no_edit': 'Ask a colleague who can edit patient details to complete the record.',
    'complete_details': 'Complete details',
    'edit_details': 'Edit details',
    'edit_patient_details': 'Edit patient details',
    'edit_patient_details_hint': 'MRN {mrn} — only what you change is saved',
    'save_changes': 'Save changes',
    'patient_details_saved': 'Patient details saved',
    'deceased_record_read_only': 'This patient is recorded as deceased; the record is read-only.',
    'patients': 'Patients',
    'search_by_mrn_name_phone_or_x': 'Search by MRN, name, phone or {label}',
    'start_typing_to_search': 'Start typing to search…',
    'all_categories': 'All categories',
    'no_patient_matches_that_search': 'No patient matches that search.',
    'search_above_or_register_a_new_patient': 'Search above, or register a new patient.',
    'mrn': 'MRN',
    'registered': 'Registered',
    'registering': 'Registering',
    'already_on_the_platform_as': 'Already on the platform as',
    'known_at': '· known at',
    'facility': 'facility',
    'their_earlier_visits_will_follow_this_record': '. Their earlier visits will follow this record.',
    'register_someone_else': 'Register someone else',
    'has_this_person_been_here_or_anywhere_before': 'Has this person been here — or anywhere — before?',
    'search_the_guardians_cnic_or_mobile_number': 'Search the guardian’s CNIC or mobile number first. One number usually covers a whole family, so pick the right person by name from what comes back.',
    'search': 'Search',
    'searching_the_platform': 'Searching the platform…',
    'nobody_on_the_platform_carries_that_cnic_or': 'Nobody on the platform carries that CNIC or number. Fill the form below to register them.',
    'already_registered_here': 'Already registered here',
    'open_their_record': 'Open their record',
    'take_them_on': 'Take them on',
    'this_is_them': 'This is them',
    'last_visit': 'Last visit ·',
    'see_all_x_earlier_visits': 'See all {length} earlier visits',
    'see_the_detail': 'See the detail',
    'visits_recorded_at_facilities_outside_this': 'Visits recorded at facilities outside this group. Every read here is written to the audit trail.',
    'looking_up_earlier_visits': 'Looking up earlier visits…',
    'those_visits_could_not_be_loaded': 'Those visits could not be loaded.',
    'no_diagnosis_recorded': 'No diagnosis recorded',
    'calendar': 'Calendar',
    'week': 'Week',
    'next': 'Next',
    'calendar_today': 'Today',
    'view': 'View',
    'filters': 'Filters',
    'compact': 'Compact',
    'live': 'Live',
    'offline': 'Offline',
    'live_updates_on': 'Changes arrive as they happen',
    'live_updates_off': 'Not connected — the calendar refreshes every minute',
    'service': 'Service',
    'consultation': 'Consultation',
    'consultation_no_service': 'Consultation (no service)',
    'length_minutes': 'Length (min)',
    'no_bookable_services_for_this_department': 'No bookable services for this department',
    'chosen_on_the_calendar_x': 'Chosen on the calendar: {time}',
    'fee_alert': 'Fee alert',
    'marked_as_not_seen': 'Marked as not seen',
    'appointment_updated': 'Appointment updated',
    'could_not_move_the_appointment': 'Could not move the appointment',
    'x_of_x_providers': '{shown} of {total} providers',
    'search_providers': 'Search providers',
    'no_providers_match': 'No providers match',
    'show_first_x': 'Show first {count}',
    'show_all': 'Show all',
    'calendar_truncated': 'Too many appointments to show at once — some are hidden. Narrow the department or the dates.',
    'no_providers_to_show': 'Nobody can be booked here yet',
    'no_providers_to_show_hint': 'Mark staff as bookable and give them clinic hours in this branch and department.',
    'open_clinic_hours': 'Open clinic hours',
    'authorisation': 'Authorisation',
    'on_hold_x_need_the_insurers_approval': 'On hold — {count, plural, one {# service needs} other {# services need}} the insurer’s approval',
    'waiting_for_the_insurer_x_sent': 'Waiting for the insurer — {count, plural, one {# service} other {# services}} sent',
    'the_insurer_has_answered_for_every_service': 'Authorised — the insurer has answered for every service',
    'send_for_authorisation': 'Send for authorisation',
    'sent_for_authorisation': 'Sent for authorisation',
    'could_not_send_for_authorisation': 'Could not send for authorisation',
    'x_to_send_x_waiting_x_answered': '{open} to send · {waiting} waiting · {answered} answered',
    'manual_payer_note': 'This payer answers outside NPHIES: the request goes to the insurance worklist and the answer is entered there.',
    'closing_sends_for_authorisation': 'Closing the consultation sends the services that still need the insurer’s approval.',
    'locked_sent_for_authorisation': 'Sent to the insurer for authorisation; cancel the pre-authorisation first',
    'locked_in_a_draft_request': 'Held in a pre-authorisation draft; send or discard the draft first',
    'auth_state_not_sent': 'Not sent',
    'auth_state_pending': 'Waiting',
    'auth_state_pended': 'Pended',
    'auth_state_approved': 'Approved',
    'auth_state_partial': 'Part-approved',
    'auth_state_rejected': 'Rejected',
    'auth_state_cancelled': 'Cancelled',
    'auth_state_not_required': 'No approval needed',
    'auth_state_drafted': 'In draft',
    'channel_nphies': 'NPHIES',
    'channel_manual': 'Manual',
    'family': 'Family',
    'linked_to': 'Linked to',
    'link_to_an_existing_patient_a_parent_spouse': 'Link to an existing patient — a parent, spouse or child. Their phone and address fill any blank fields, and a minor gets them as guardian.',
    'the_linked_patient_is_this_patients': 'The linked patient is this patient’s…',
    'relation_mother': 'Mother',
    'relation_father': 'Father',
    'relation_parent': 'Parent',
    'relation_child': 'Child',
    'relation_spouse': 'Spouse',
    'relation_sibling': 'Sibling',
    'relation_other': 'Other relative',
    'relation_relative': 'Family member',
    'no_family_links_yet': 'No family links yet',
    'link_a_family_member': 'Link a family member',
    'link_x_to_a_family_member': 'Link {name} to a family member',
    'the_record_joins_the_other_patients_family': 'The record joins the other patient’s family. A minor gets them as guardian; a mother is also recorded for newborn cover.',
    'family_member_linked': 'Family member linked',
    'could_not_link_the_family_member': 'Could not link the family member',
    'loading_the_family': 'Loading the family',
    'link': 'Link',
    'cash': 'Cash',
    'valid_to_x': 'valid to {date}',
    'coverages_not_valid_on_this_day': 'Some of the patient’s coverages are not valid on this day',
    'appointment': 'Appointment',
    'slot_outside_session': 'Outside clinic hours',
    'slot_outside_session_hint': 'Pick a time inside one of the shaded clinic sessions.',
    'slot_blocked': 'Provider is not available',
    'slot_blocked_hint': 'That time falls inside leave or blocked time for this provider.',
    'slot_past': 'That time has passed',
    'slot_past_hint': 'Pick a time from now onwards.',
    'booked_x_of_y_places': '{booked} / {places} booked',
    'x_arrived': '{count} arrived',
    'book_at_x': 'Book at {time}',
    'book_at_x_with_y': 'Book {time} with {doctor}',
    'slot_at_x_with_y': '{time} with {doctor}',
    'fee_issue_no_fee_rule': 'no consultation fee is set for this doctor',
    'fee_issue_no_price': 'the consultation item has no price',
    'fee_issue_coverage_invalid': 'the patient’s insurance cover is not valid today',
    'fee_issue_error': 'the fee invoice could not be created',
    'pick_a_coverage': 'Pick a coverage',
    'no_coverage_valid_on_this_day': 'No coverage is valid on this day',
    'payer_from_last_visit': 'Taken from the patient’s last visit',
    'check_eligibility': 'Check eligibility',
    'eligibility_check_failed': 'The insurer could not be asked',
    'x_currently_x': '{fullName} · now {payer}',
    'consultation_fee_unpaid': 'Consultation fee unpaid',
    'fee_unpaid_collect_before_closing': 'The consultation fee has not been paid. Collect it at the counter before the consultation is closed.',
    'fee_unpaid_collect_at_counter': 'The consultation fee has not been paid; collect it at the counter.',
    'collect_at_counter': 'Collect at counter',
    'check_payment_again': 'Check payment again',
    'close_needs_the_fee_paid': 'The consultation fee must be paid before closing',
    'close_without_payment': 'Close without payment',
    'say_why_the_consultation_closes_unpaid': 'Say why the consultation is closing with the fee unpaid; the reason stays on the record.',
    'x_with_the_doctor_have_not_paid_the_fee': '{count} patient(s) with the doctor have not paid the consultation fee; collect it at the counter.',
    'clinic_hours_replace_note': 'Saving replaces this doctor\'s weekly hours in the chosen department from today. Appointments already booked keep their times.',
    'select_a_department': 'Select a department',
    'choose_the_department_first': 'Choose the department first',
    'no_doctor_in_this_department_takes_appointments': 'No doctor in this department takes appointments yet',
    'doctors_without_department_x': 'These doctors take appointments but are not in any department of this branch, so they cannot have clinic hours yet: {names}. Add them to a department under Staff & roles.',
    'doctor_has_no_department': 'This doctor is not placed in any department of this branch. Add one under Staff & roles first.',
    'open_staff_and_roles': 'Open Staff & roles',
    'pick_department_for_old_hours': 'These hours were saved before departments existed. Pick the department they belong to; saving replaces them.',
    'choose_doctor_and_department_first': 'Choose the doctor and the department to set the weekly hours.',
    'working': 'Working',
    'not_working': 'Off',
    'add_period': 'Add period',
    'remove_period': 'Remove period',
    'apply_to_all_days': 'Apply to all days',
    'replace_other_days_title': 'Replace the other days?',
    'replace_other_days_body': '{count} other day(s) already have different hours. Applying {day} to all days replaces them.',
    'replace_hours': 'Replace',
    'turn_on_a_working_day': 'Turn on at least one working day.',
    'periods_overlap_on_day': 'On {day}, {first} and {second} overlap.',
    'no_department_pick_when_editing': 'No department; pick one when you edit',
    'follow_up_after_this_visit': 'Follow-up',
    'follow_up_none': 'No follow-up',
    'follow_up_free': 'Free',
    'follow_up_paid': 'Paid',
    'follow_up_discounted': 'Discounted',
    'follow_up_discount_percent': 'Discount (%)',
    'follow_up_valid_for_days': 'Valid for (days)',
    'follow_up_decision_hint': 'If the patient returns to you inside this time they are booked as a follow-up on these terms. The payment rule still applies unless the follow-up is free.',
    'follow_up_free_until_x': 'Follow-up: free until {date}',
    'follow_up_discount_until_x': 'Follow-up: {percent}% off until {date}',
    'follow_up_full_fee_until_x': 'Follow-up: full fee until {date}',
    'bill_now': 'Bill now',
    'visit_billed': 'The consultation is billed',
    'could_not_bill_the_visit': 'Could not bill the visit',
    'billing_still_blocked': 'The fee still cannot be billed. Set a fee for the doctor or check the patient’s coverage, then try again.',
    'io_ord_cannot_here': 'Cannot be done here',
    'io_ord_blocked_outside': 'Remove the items that cannot be done here; an inpatient order is always done in this hospital',
    'io_ord_placed_stay': 'Billed to the stay; the ward sees its tasks',
    'io_ord_lines_lab': 'Lab orders of this stay',
    'io_ord_lines_radiology': 'Imaging of this stay',
    'io_ord_lines_procedure': 'Procedures of this stay',
    'photo': 'Photo',
    'photo_hint': 'Taken at the desk or chosen from a file; it is made smaller before it is sent',
    'photo_take': 'Take photo',
    'photo_choose': 'Choose photo',
    'photo_replace': 'Replace photo',
    'photo_remove': 'Remove photo',
    'photo_keep': 'Keep the photo',
    'photo_unreadable': 'That file could not be read as an image',
    'photo_too_large': 'That image is still too large after making it smaller',
    'photo_upload_failed': 'The photo could not be uploaded',
    'photo_not_saved_x': 'The details were saved but the photo was not: {error}',
    'mrn_likely': 'Likely',
    'mrn_likely_hint': 'Another registration may take this number first',
    'section_insurance': 'Insurance',
    'section_insurance_hint': 'Add the patient’s policy now, or later from their record',
    'optional': 'Optional',
    'insurance_cover': 'Cover',
    'insurance_none': 'No insurance',
    'insurance_add': 'Add a policy',
    'insurance_payer': 'Payer',
    'insurance_choose_payer': 'Choose a payer',
    'insurance_plan': 'Plan',
    'insurance_no_plan': 'No plan',
    'insurance_member_number': 'Member or policy number',
    'insurance_valid_from': 'Valid from',
    'insurance_valid_until': 'Valid until',
    'insurance_dates_reversed': 'The end date is before the start date',
    'insurance_card_image': 'Insurance card',
    'insurance_card_image_hint': 'Optional; kept with the patient’s documents',
    'insurance_card_document_title': 'Insurance card',
    'insurance_card_remove': 'Remove image',
    'insurance_incomplete': 'Finish the insurance details, or set Cover to No insurance',
    'extra_photo_saved': 'Photo saved',
    'extra_photo_failed': 'The photo was not saved',
    'extra_insurance_saved': 'Insurance policy added',
    'extra_insurance_failed': 'The insurance policy was not added',
    'extra_card_saved': 'Insurance card saved',
    'extra_card_failed': 'The insurance card was not saved',
    'extra_state_saved': 'Saved',
    'extra_state_failed': 'Failed',
    'extra_retry': 'Try again',
    'extra_fix_on_record': 'Fix it on the record',
    'extra_retry_unavailable': 'There is nothing to try again',
    'person_registering_x': 'Registering {name}',
    'person_known_on_platform': 'Already on the platform as {uhid}, known at {count, plural, one {# facility} other {# facilities}}. Their earlier visits will follow this record.',
    'person_born_x': 'born {date}',
    'person_about_years': 'about {count, plural, one {# year} other {# years}}',
    'person_seen_at_facilities': 'seen at {count, plural, one {# facility} other {# facilities}}',
    'qp_department_hint': 'Offered by your department',
    'er_not_triaged': 'Not triaged',
    'overlaps_with_x': 'Overlaps with {range}. Change the time or remove one period.',
};
//# sourceMappingURL=opd.js.map